export const GET_AGREEMENTS = 'GET_AGREEMENTS';
export const POST_AGREEMENTS = 'POST_AGREEMENTS';
export const REQUIRED_VERSION = '20240524';
export const POLICY_CONTENT_URL_BASE =
  'https://antaa-public.s3.ap-northeast-1.amazonaws.com/agreements/privacy-policy/privacy-policy-';
export const POLICY_SUMMARY_URL_BASE =
  'https://antaa-public.s3.ap-northeast-1.amazonaws.com/agreements/privacy-policy/summary/privacy-policy-';
